import { useHookstate } from '@hookstate/core';
import { FC, useCallback, useMemo } from 'react';
import { useMobileOrientation } from 'react-device-detect';
import { Part } from '../../components/GamePart';
import { PartWinnerPreviewSGLandscape } from '../../components/PartWinnerPreviewSG/landscape';
import { PartWinnerPreviewSGPortrait } from '../../components/PartWinnerPreviewSG/portrait';
import { useFormatCurrency } from '../../hooks/use-format-currency';
import { usePartWinners } from '../../hooks/use-part-winners';
import { useWinners } from '../../hooks/use-winners';
import { current, meta, winners as winnersState } from '../../stores/backend';

export const PartWinnerPreviewSG: FC = () => {
    const $current = useHookstate(current);
    const $meta = useHookstate(meta);
    const $winners = useHookstate(winnersState);

    const currentPart = $current.current_part.value || 0;

    const formatCurrency = useFormatCurrency($current, $meta);

    const winners = useWinners($winners, currentPart, formatCurrency);

    const partWinners = usePartWinners();

    const parts = useMemo(
        () => Object.keys($current.game_parts.value).length,
        [$current.game_parts]
    );

    const onClick = useCallback(() => {
        $meta.modals.partWinners.set(true);
    }, [$meta.modals.partWinners]);

    const orientation = useMobileOrientation();

    const Component = orientation.isPortrait
        ? PartWinnerPreviewSGPortrait
        : PartWinnerPreviewSGLandscape;

    if (partWinners) {
        return (
            <Component
                gameParts={parts as Part}
                currentPart={(currentPart + 1) as Part}
                winner={winners[0]}
                handleClick={onClick}
            />
        );
    }

    return null;
};
